import React from 'react'
import { TextField } from 'foundations-library/components'
import { TextFieldType } from 'foundations-library/types'
import { formatAsYouType, isValidPhoneNumber, convertNumberToE164 } from 'phone-numbers'

const formatValue = (value: string, countryCode): string => {
    let formatted = value
    if (formatted.length === 1) formatted = formatted.trim()

    if (isValidPhoneNumber(formatted) || (formatted.length > 5 && !/[a-zA-Z]/g.test(formatted))) {
        formatted = formatAsYouType(formatted, countryCode)
    }

    return formatted
}

type PropsType = {
    onFormatChange?(v): unknown
    countryCode: string
} & Omit<TextFieldType, 'type'>

/**
 *
 */
const PhoneNumberInputField = ({
    onFormatChange,
    countryCode = 'US',
    onChange,
    ...props
}: PropsType): JSX.Element => {
    const handleOnChange = (newValue: string) => {
        const formattedValue = formatValue(newValue, countryCode)
        onChange?.(formattedValue)
        onFormatChange?.(convertNumberToE164(newValue))
    }

    return <TextField
        type='tel'
        {...props}
        value={formatValue(props.value, countryCode)}
        onChange={handleOnChange}
    />
}

export default PhoneNumberInputField
